//Library Imports
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "store";

//Local Imports
import { getQueryCampaignId } from "modules/EmailBrowser/utils";
import { IVersion } from "modules/Campaigns/interfaces";
import { getAllEmailsSent } from "../actions";

import { EMAIL_LIST } from "constants/types";
import EditionsList from "./EditionsList";

interface IAllEditionsWrapper {
  isSearch?: boolean;
  previousSentSearch?: string;
}

const DEFAULT_PAGE_LIMIT = 20; //* later on api hits

const AllEditionsSentWrapper: React.FC<IAllEditionsWrapper> = (props: IAllEditionsWrapper) => {
  //Others
  const { isSearch, previousSentSearch } = props;
  const assetType: any = useSelector((state: RootState) => state.assetDetails.assetType);
  const campaignId = getQueryCampaignId();

  //Sent Editions
  const allEditionsLoading: boolean = useSelector((state: RootState) => state.emails?.allSentEmails?.loading);
  const allEditions: IVersion[] = useSelector((state: RootState) => state.emails?.allSentEmails?.data);
  const hasMoreAll = useSelector((state: RootState) => state.emails?.hasMoreAllSent);
  const searchSentLoading: boolean = useSelector((state: RootState) => state.assetDetails.searchSentLoading);

  const getPagination = (isFirstLoad = false) => {
    let offset = 0;
    if (!isFirstLoad) {
      offset = allEditions.length;
    }
    let limit = DEFAULT_PAGE_LIMIT; //update to 4

    return {
      offset,
      limit,
      asset_id: campaignId,
      version_status: "Sent",
    };
  };

  const loadMore = () => {
    if (!allEditionsLoading) {
      if (isSearch) {
        getAllEmailsSent(campaignId, { ...getPagination(), search_term: previousSentSearch });
      } else {
        getAllEmailsSent(campaignId, getPagination());
      }
    }
  };

  useEffect(() => {
    const updatedRest = store.getState().emails.reset;
    if (allEditions.length === 0 || updatedRest) {
      getAllEmailsSent(campaignId, getPagination(true), false, updatedRest);
    } else store.dispatch({ type: EMAIL_LIST.SENT_LOAD_OFF });
  }, []);

  return (
    <>
      <EditionsList
        editionsLength={allEditions.length}
        loadMore={loadMore}
        hasMore={hasMoreAll}
        editionsLoading={allEditionsLoading}
        editions={allEditions}
        campaignId={campaignId}
        assetType={assetType}
        isSearch={isSearch}
        noEmailText={`No emails found.`}
        noSearchEmailText={`No emails found against your search`}
        searchSentLoading={searchSentLoading}
      />
    </>
  );
};

export default AllEditionsSentWrapper;

AllEditionsSentWrapper.defaultProps = {};
